import React, { memo } from 'react';
import PropTypes from 'prop-types';

const FormHeader = ({ text, expanded = false }) => {
    return (
        <a className="c-form-section__header  js-form-section__header">
            <span className="c-form-section__header-content">
                <span
                    className="c-form-section__title  js-form-section__trigger"
                    aria-expanded={expanded}
                >
                    <span className="c-form-section__title-text" role="heading">
                        {text}
                    </span>
                </span>
            </span>
            <span className="c-form-section__header-icon" />
        </a>
    );
};

FormHeader.propTypes = {
    text: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
};

export default memo(FormHeader);
